export default __webpack_public_path__ + "static/tmtweewielers-014b86f8aeed19ff18bd283a318ce941.mp4";